import * as tslib_1 from "tslib";
import { environment } from './../../../environments/environment';
var LocalConsole = /** @class */ (function () {
    function LocalConsole() {
    }
    LocalConsole.prototype.log = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        if (environment.local || environment.sit) {
            console.log.apply(console, tslib_1.__spread(data));
        }
    };
    return LocalConsole;
}());
export var localConsole = new LocalConsole();
